/**
 * Selectable tracker tile (Voluum / Binom / Tres Commas) for TrafficSourceDialog.
 * A tracker without a logo shows its `mark` (the amber Tres Commas badge) instead.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface ProviderPickCardProps {
  label: string;
  image?: string;
  mark?: ReactNode;
  selected: boolean;
  onSelect: () => void;
  disabled: boolean;
}

export const ProviderPickCard: FC<ProviderPickCardProps> = ({
  label,
  image,
  mark,
  selected,
  onSelect,
  disabled,
}) => (
  <button
    type="button"
    onClick={onSelect}
    disabled={disabled}
    className={cn(
      'flex flex-col items-center gap-2 rounded-lg border-2 p-3 transition-colors',
      selected ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40',
      disabled && 'pointer-events-none opacity-60',
    )}
  >
    {image ? (
      <img src={image} alt="" className="h-8 w-auto object-contain" />
    ) : (
      <span className="flex h-8 items-center">{mark}</span>
    )}
    <span className="text-xs font-medium">{label}</span>
  </button>
);
